import { makeAspectCrop, centerCrop, Crop } from 'react-image-crop';

export const log = (...args: unknown[]) => !__LOGGING__ || console.log(...args);

export const toPrice = (price: number) => {
  return new Intl.NumberFormat('it-IT', {
    style: 'currency',
    currency: 'EUR'
  }).format(price);
};

// const EXCLUDE_FIELDS = ['sb:HasInput', 'sb:HasOutput'];

export const gs1 = (v: string) => `https://gs1.org/voc/${v}`;

export const sb = (v: string, dashed = false) =>
  `http://seedsbit${dashed ? '_' : '.'}com/ontology/#${v}`;

export const isGroup = (schema: string | null) => schema === sb('Group');

export const isProcess = (schema: string | null) => schema?.endsWith('Process') ?? false;

export const readFileAsArrayBuffer = (file: File) => {
  return new Promise<ArrayBuffer>((res, rej) => {
    const reader = new FileReader();
    reader.addEventListener('load', async (event) => {
      const output = event.target?.result;
      if (!output) {
        rej(new Error('Cannot read file'));
      }
      res(output as ArrayBuffer);
    });
    reader.readAsArrayBuffer(file);
  });
};

export const fileToBlob = async (file: File) =>
  new Blob([new Uint8Array(await file.arrayBuffer())], { type: file.type });

export const calcCropByRation = (src: string, aspectRatio: number, key = 'width') => {
  return new Promise<Crop>((res) => {
    const img = new Image();
    img.onload = () => {
      const { width, height } = img;
      res(
        centerCrop(
          makeAspectCrop(
            {
              unit: '%',
              [key]: 100
            },
            aspectRatio,
            width,
            height
          ),
          width,
          height
        )
      );
    };
    img.src = src;
  });
};

export const readFileAsDataImage = (file: File) => {
  return new Promise<string | undefined>((res) => {
    const reader = new FileReader();
    reader.addEventListener('load', async (event) => {
      const output = event.target?.result;
      res((output as string) ?? undefined);
    });
    reader.readAsDataURL(file);
  });
};

export const base64ToBlob = async (value: string) => {
  const res = await fetch(value);
  const blob = await res.blob();
  const type = blob.type;
  const ext = type.split('/')[1];
  return new File([blob], `${crypto.randomUUID()}.${ext}`, { type });
};

export const prefixPath = (type: string) => {
  switch (type) {
    case 'product':
    case 'process':
    case 'document':
      return '/page';
    case 'companyProduct':
      return '/lot';
    default:
      return `/${type}`;
  }
};
